import React from 'react';
import Image from 'next/image';
import { Box, type Theme, Typography } from '@mui/material';
import { useI18nContext } from '@procore/core-react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useHeroProjectOpenToBidStyles } from './Hero.styles';
import ImageLoader from '../utils/ImageLoader';
import SearchBarWithTabs from '../Search/SearchBarWithTabs';
import ProcoreHexIcon from '../Icons/ProcoreHexIcon';
import { CANADA, DEFAULT_COUNTRY } from '../../data/location/countries';
import { useRouter } from 'next/router';

const Hero = () => {
  const I18n = useI18nContext();
  const classes = useHeroProjectOpenToBidStyles();
  const xmView = useMediaQuery((theme: Theme) => theme.breakpoints.down(414));
  const smView = useMediaQuery((theme: Theme) => theme.breakpoints.down(600));
  const mdView = useMediaQuery((theme: Theme) => theme.breakpoints.down(800));
  const { locale } = useRouter();
  const country =
    locale === 'en-CA' || locale === 'fr-CA' ? CANADA : DEFAULT_COUNTRY;

  const networkName = I18n.t('pages.pcn');
  const title = I18n.t('components.hero.title');

  let HeroImage;
  if (smView) {
    HeroImage = (
      <Image
        loader={ImageLoader}
        src="/hero/small.webp"
        alt=""
        height={506}
        width={414}
        priority
        loading="eager"
        style={
          xmView
            ? {
                maxWidth: '100%',
                height: '100%',
              }
            : {
                width: '100%',
                height: '100%',
              }
        }
      />
    );
  } else if (mdView) {
    HeroImage = (
      <Image
        loader={ImageLoader}
        src="/hero/medium.webp"
        alt=""
        height={1000}
        width={1536}
        priority
        loading="eager"
        sizes="100vw"
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    );
  } else {
    HeroImage = (
      <Image
        loader={ImageLoader}
        src="/hero/large.webp"
        alt=""
        height={1412}
        width={2880}
        priority
        loading="eager"
        sizes="100vw"
        style={{
          width: '100%',
          height: '100%',
        }}
      />
    );
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.imageContainer}>{HeroImage}</Box>
      <Box className={classes.content}>
        <Box className={classes.networkNameContainer}>
          <ProcoreHexIcon />
          <Typography variant="h3" className={classes.networkName}>
            {networkName}
          </Typography>
        </Box>
        <Typography variant="h1" className={classes.title}>
          {title}
        </Typography>
        <Box className={classes.searchBarRow}>
          <SearchBarWithTabs smView={smView} isCanada={country === CANADA} />
        </Box>
      </Box>
    </Box>
  );
};

export default Hero;
